import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Tab, Typography } from '../../../components'
import { PaymentMethod } from '../../../constants/order'
import useActions from '../../../hooks/useActions'
import useScrollToTop from '../../../hooks/useScrollToTop'
import { signUpActions } from '../../../redux/ducks/signUp'

import * as S from '../styles'
import BankSlipForm from './BankSlipForm'
import CreditCardForm from './CreditCardForm'
import PixForm from './PixForm'

const StepFour = () => {
  const { setError } = useActions(signUpActions)
  const signUpState = useSelector((state) => state.signUp)
  const { success } = signUpState?.step5?.purchase ?? {}
  const { productSelected } = signUpState?.step3 ?? {}
  const [paymentMethod, setPaymentMethod] = React.useState(
    productSelected?.isCreditCard
      ? PaymentMethod.CREDIT_CARD
      : PaymentMethod.BANK_SLIP
  )
  const { scrollToTop } = useScrollToTop()

  useEffect(() => {
    scrollToTop()
  }, [scrollToTop])

  useEffect(() => {
    // Limpa mensagem de erro no formulário
    setError('')
  }, [paymentMethod, setError])

  return (
    <S.StepContainer>
      {!success && (
        <>
          <Typography
            type="text"
            color="#7D7987"
            spacing="0 0 1.5rem 0"
            align="center"
          >
            Escolha o pagamento
          </Typography>
          <Tab margin="0 auto">
            {productSelected.isCreditCard && (
              <Tab.Item
                name="paymentMethod"
                label="Cartão de crédito"
                onClick={() => setPaymentMethod(PaymentMethod.CREDIT_CARD)}
                checked={paymentMethod === PaymentMethod.CREDIT_CARD}
              />
            )}
            {productSelected.isBankSlip && (
              <Tab.Item
                name="paymentMethod"
                label="Boleto bancário"
                onClick={() => setPaymentMethod(PaymentMethod.BANK_SLIP)}
                checked={paymentMethod === PaymentMethod.BANK_SLIP}
              />
            )}
            {productSelected.isPix && (
              <Tab.Item
                name="paymentMethod"
                label="Pix"
                onClick={() => setPaymentMethod(PaymentMethod.PIX)}
                checked={paymentMethod === PaymentMethod.PIX}
              />
            )}
          </Tab>
        </>
      )}
      {paymentMethod === PaymentMethod.CREDIT_CARD && <CreditCardForm />}
      {paymentMethod === PaymentMethod.BANK_SLIP && <BankSlipForm />}
      {paymentMethod === PaymentMethod.PIX && <PixForm />}
    </S.StepContainer>
  )
}

export default StepFour
